async function submitFormAfterValidation(formData) {
    try {
        let response = await fetch('/api/submission/', {
            method: 'POST',
            body: formData
        });

        let result = await response.json();

        if (result.success) {
            const categories   = Array.from(document.querySelectorAll('input[name="category[]"]:checked')).map(el => el.getAttribute('data-shopify') + ':1');
            const submissionId = result.submissionId
            const shopifyCheckoutUrl = 'https://submit.goldeneschindel.at/cart/' + categories.join(',') + '?note=' + submissionId + '&checkout[email]=' + formData.get('email') + '&checkout[billing_address][first_name]=' + formData.get('name') + '&checkout[billing_address][last_name]=' + formData.get('surname');

            window.open(shopifyCheckoutUrl, '_blank')

            // Hide form and show confirmation message
            document.getElementById('submission').style.display = 'none'
            document.getElementById('confirmationMessage').style.display = 'block'
            document.getElementById('shopifyLink').href = shopifyCheckoutUrl

            // scroll to top
            const section = document.querySelector(".block.block--form")
            section.scrollIntoView({ behavior: "smooth", block: "start" })
        } else {
            alert('Order submission failed. Please try again.');
        }
    } catch (error) {
        console.error('Error:', error);
        alert('An error occurred. Please check your connection and try again.');
    }
}